// angular.module('app.prospection.store', [
//     'app.prospection.search',
//     'leaflet-directive'
// ]);
/**
 * Module stores prospection
 * @module app.prospection.store
 */
define([
    'angular',
    'modules/prospection/store/controllers/appointmentCtrl',
    'modules/prospection/store/controllers/gpsCtrl',
    'modules/prospection/store/controllers/glpiTicketsCtrl',
    'modules/prospection/store/controllers/storeCtrl',
    'modules/prospection/store/controllers/storeListCtrl',
    'modules/prospection/store/controllers/businessCtrl',
    'modules/prospection/store/controllers/disposalCtrl',
    'modules/prospection/store/controllers/modals/updateBusinessCtrl',
    'modules/prospection/store/controllers/modals/walletCreateUpdateClientCtrl',
    'modules/prospection/store/controllers/reminderCtrl',
    'modules/prospection/store/controllers/callsCtrl',
    'modules/prospection/store/controllers/modals/callSummaryCtrl',
    'modules/prospection/store/factories/activitiesService',
    'modules/prospection/store/factories/appointmentService',
    'modules/prospection/store/factories/appointmentBackendProvider',
    'modules/prospection/store/factories/fournisseurService',
    'modules/prospection/store/factories/storeBackendProvider',
    'modules/prospection/store/factories/storeService',
    'modules/prospection/store/factories/glpiService',
    'modules/prospection/store/factories/glpiBackendProvider',
    'modules/prospection/store/factories/disposalService',
    'modules/prospection/store/factories/disposalBackendProvider',
    'modules/prospection/store/factories/appointmentFiltersService',
    'modules/prospection/store/factories/callsService',
    'modules/prospection/store/factories/callsBackendProvider',
    'angular-leaflet-directive'
], function(angular) {


    function prospectionStoreRouter($routeProvider) {
        $routeProvider.when('/prospection/store/', {
            templateUrl: 'prospection/store/partials/stores.html',
            controller: 'StoreListCtrl',
            controllerAs: 'storeListCtrl',
            resolve: {
                localstores: [
                    'storeService',
                    function(storeService) {
                        return storeService.get();
                    }
                ],
                mode: [
                    'departementsService',
                    '$route',
                    function(departementsService) {
                        return { name: 'departements', list: departementsService.getSelectedList(), query: [] };
                    }
                ]
            }
        });
        $routeProvider.when('/prospection/store/around/:query', {
            templateUrl: 'prospection/store/partials/stores.html',
            controller: 'StoreListCtrl',
            controllerAs: 'storeListCtrl',
            resolve: {
                localstores: [
                    'storeService',
                    '$route',
                    function(storeService, $route) {
                        return storeService.searchAround($route.current.params.query);
                    }
                ],
                mode: [
                    '$route',
                    function($route) {
                        var re = /^([0-9\.+\-]+),([0-9\.+\-]+)(\?near=([0-9]+))/;
                        var res = re.exec($route.current.params.query);
                        var pos = { lat: res[1], long: res[2], radius: +res[4] / 1000 };
                        return { name: 'geo', near: pos, query: $route.current.params.query};
                    }
                ]
            }
        });
        $routeProvider.when('/prospection/store/around/many/:query', {
            templateUrl: 'prospection/store/partials/stores.html',
            controller: 'StoreListCtrl',
            controllerAs: 'storeListCtrl',
            resolve: {
                localstores: [
                    'storeService',
                    '$route',
                    function(storeService, $route) {
                        return storeService.searchAroundManyAddress($route.current.params.query);
                    }
                ],
                mode: [
                    '$route',
                    function($route) {
                        const distance = $route.current.params.query.split('?')[1].split('&')[0].split('=')[1];
                        return { name: 'geo-multi', near:{radius: distance / 1000 }, query: $route.current.params.query};
                    }
                ]
            }
        });
        $routeProvider.when('/prospection/store/search/:query', {
            templateUrl: 'prospection/store/partials/stores.html',
            controller: 'StoreListCtrl',
            controllerAs: 'storeListCtrl',
            resolve: {
                localstores: [
                    'storeService',
                    '$route',
                    function(storeService, $route) {
                        return storeService.search($route.current.params.query);
                    }
                ],
                mode: [
                    '$route',
                    function($route) {
                        return { name: 'text', query: $route.current.params.query };
                    }
                ]
            }
        });
        $routeProvider.when('/prospection/store/advance_search/:query', {
            templateUrl: 'prospection/store/partials/stores.html',
            controller: 'StoreListCtrl',
            controllerAs: 'storeListCtrl',
            resolve: {
                localstores: [
                    'storeService',
                    '$route',
                    function(storeService, $route) {
                        return storeService.advanceSearch($route.current.params.query);
                    }
                ],
                mode: [
                    '$route',
                    function($route) {
                        return { name: 'advanced', query: $route.current.params.query };
                    }
                ]
            }
        });
        $routeProvider.when('/prospection/store/:identifiant_magasin/', {
            templateUrl: 'prospection/store/partials/store.html',
            controller: 'StoreCtrl',
            controllerAs: 'storeCtrl',
            resolve: {
                store: [
                    'storeService',
                    '$route',
                    function(storeService, $route) {
                        return storeService.getById($route.current.params.identifiant_magasin);
                    }
                ]
            }
        });
        $routeProvider.when('/prospection/reminder/', {
            templateUrl: 'prospection/store/partials/reminders.html',
            controller: 'ReminderCtrl',
            controllerAs: 'reminderCtrl'
        });
    }

    prospectionStoreRouter.$inject = ['$routeProvider'];

    angular
        .module('app.prospection.store', [
            'app.prospection.store.appointmentCtrl',
            'app.prospection.store.gpsCtrl',
            'app.prospection.store.glpiTicketsCtrl',
            'app.prospection.store.storeCtrl',
            'app.prospection.store.storeListCtrl',
            'app.prospection.store.businessCtrl',
            'app.prospection.store.updateBusinessCtrl',
            'app.prospection.store.disposalCtrl',
            'app.prospection.store.callsCtrl',
            'app.prospection.store.callSummaryCtrl',
            'app.prospection.store.walletCreateUpdateClientCtrl',
            'app.prospection.store.activitiesService',
            'app.prospection.store.appointmentService',
            'app.prospection.store.appointmentBackend',
            'app.prospection.store.fournisseurService',
            'app.prospection.store.storeBackend',
            'app.prospection.store.storeService',
            'app.prospection.store.glpiService',
            'app.prospection.store.glpiBackend',
            'app.prospection.store.disposalService',
            'app.prospection.store.disposalBackend',
            'app.prospection.store.reminderCtrl',
            'app.prospection.store.appointmentFiltersService',
            'app.prospection.store.callsService',
            'app.prospection.store.callsBackend',
            'leaflet-directive'
        ])
        .config(prospectionStoreRouter);
});
